import { Component, Input } from '@angular/core';
import { finalize } from 'rxjs/operators';
import { NgxSpinnerService } from 'ngx-spinner';
import { FileDownloadApiService } from '@shared/apis/file-download-api.service';
import Utils from '@shared/utils/utils';

@Component({
  selector: 'app-dk-export',
  templateUrl: './dk-export.component.html',
  styleUrls: ['./dk-export.component.scss']
})
export class DkExportComponent {

  @Input() fileType: string;
  @Input() downUrl: string;
  @Input() query: any;          // pass as params[query], send query directly
  @Input() params: any;         // pass as params, deconstruct object into parameters
  @Input() q: any;              // quick send it as parameters

  constructor(private spinnerService: NgxSpinnerService,
              private fileDownloadApiService: FileDownloadApiService) {
  }

  onClickExport(): void {
    Utils.showConfirm('Do you want to export the list?', 'Yes', 'Cancel')
      .then(result => {
        if (result === 'Yes') {
          const fileType = this.fileType;
          let downUrl = this.downUrl;

          if (downUrl.startsWith('/')) {
            downUrl = downUrl.substring(1);
          }

          this.spinnerService.show().then();
          const params = this.params || {};
          if (this.query) {
            params.query = JSON.stringify(this.query);
          }
          if (this.q) {
            params.q = this.q;
          }
          this.fileDownloadApiService.fileDownload(downUrl, fileType, params).pipe(
            finalize(() => this.spinnerService.hide().then()))
            .subscribe(res => {
              Utils.showMessage(res.messages ? res.messages[0] : 'Data will be emailed to you shortly.');
            }, err => {
              Utils.showError(err);
            });
        }
      });
  }
}
